import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-under-construction-dialogue',
  templateUrl: './under-construction-dialogue.component.html',
  styleUrls: ['./under-construction-dialogue.component.scss']
})
export class UnderConstructionDialogueComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<UnderConstructionDialogueComponent>,) {
    
   }

  ngOnInit(): void {
  }
  closeDialog() {
    this.dialogRef.close();
  }

}
